import React from 'react'
import {useSelector} from 'react-redux'
import {HotelAccommodationDesktopView} from 'components/Accommodation/AccommodationView/Desktop/HotelAccommodationDesktopView'
import {useHotelSlug} from 'hooks/useHotelSlug'
import {getHotelResult} from 'modules/searchApi/selectors'

const AccommodationViewDesktop: React.FC = () => {
  const hotelSlug = useHotelSlug()
  const {
    data: hotel,
    isLoading,
    isUninitialized
  } = useSelector(state => getHotelResult(state, hotelSlug))
  return (
    <HotelAccommodationDesktopView
      hotel={hotel}
      isLoading={isLoading || isUninitialized}
    />
  )
}

export default AccommodationViewDesktop
